<template>
  <el-card>
    <el-form-item>
      <el-button @click="printPreview" :loading="loading">预览</el-button>
      <el-button @click="print" :loading="loading">打印</el-button>
      <KfMessage ref="commitMessage"></KfMessage>
    </el-form-item>
    <el-form-item>
      <div id="divPrint">
        <img class="preview-img" :src="imageBase64" v-for="(imageBase64,index) in imageBase64List" :key="index"
             :style="'width:' + imageWidth + 'px; height:' + imageHeight + 'px;'" v-if="imageBase64.length > 0">
      </div>
    </el-form-item>
  </el-card>
</template>

<script>
export default {
  name: "BusCarInfoPrint",
  props: {
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      //num: 0,
      imageBase64: '',
      imageHeight: 350,
      imageWidth: 500,
      imageBase64List: [],
      loading: false,
      printDto: {},
    }
  },
  methods: {

    async printPreview() {
      this.imageBase64List = []
      this.loading = true;
      await this.$axios.post('bus/print/createCarInfoLabel', this.parentData).then(response => {
        this.loading = false;
        let res = response.data

        if (res.code !== 0) {
          return this.$message.error(res.message);
        } else {
          this.printDto = res.data;
          for (let i = 0; i < res.data.length; i++) {
            this.imageBase64 = res.data[i].imageBase64 || '';
            if (this.imageBase64.length > 0) {
              this.imageBase64 = "data:image/jpeg;base64," + this.imageBase64;
              this.imageBase64List.push(this.imageBase64);
            }
          }
        }

      }, error => {
        this.loading = false;
        this.$refs.commitMessage.showError(`生成打印图像失败，${error.message}`);
      })
    },

    async print() {
      await this.printPreview();
      this.loading = false;

      // if (this.imageBase64List.length > 0) {
      //   //调用打印,等待100毫秒
      //   //setTimeout(this.printDiv, 2000);
      //   // this.printDiv();
      // }

      for (let i = 0; i < this.imageBase64List.length; i++) {
        if (!this.imageBase64List[i] || this.imageBase64List[i].length === 0) {
          return;
        }

        this.loading = true;
        // if (i === this.imageBase64List.length - 1) {
        //   this.updatePrintedCount();
        // }
        //调用本地打印服务器
        // var printParams = {printer_name: this.printDto[i].printerName, zpl: this.printDto[i].zpl};
        await this.$axios.post(process.env.VUE_APP_PRINT_URL, this.printDto[i]).then(response => {
          this.loading = false;
          let res = response.data
          console.log(res)
          //
          // this.parentData.boLiNo = this.printDto[i].boLiNo
          // this.parentData.printed_count = this.parentData.printed_count + 1;
          // this.addPrintRecord();
          // if (i === this.imageBase64List.length - 1) {
          //   this.updatePrintedCount();
          // }
        }, error => {
          this.loading = false;
          console.log(`提交打印失败，${error.message}`)
          this.$message.error('连接打印机失败，请检查打印机状态。');
        })
      }
    },

    printDiv() {
      //打印div
      //打开一个新窗口newWindow
      var newWindow = window.open("打印窗口", "_blank");
      //要打印的div的内容
      var docStr = document.getElementById("divPrint").innerHTML;
      //打印内容写入newWindow文档
      newWindow.document.write(docStr);
      //关闭文档
      newWindow.document.close();

      //调用打印机
      setTimeout(() => {
        newWindow.print();
        newWindow.close();
      }, 50);

      return false;
    }

  }
}
</script>

<style scoped>
.preview-img {
  width: 500px;
  height: 350px;
  border: solid 1px #a1a1a1;
}
</style>